
import { defineComponent } from 'vue';
import { baseFileUrl } from '@/utils/constants';
import DetailIcon from '@/components/icons/DetailIcon.vue';
import PreviewImageModal from '@/components/preview-image/PreviewImageModal.vue';

interface PartVehicleItemProps {
  previewImg: string[];
  [key: string]: any;
}

export default defineComponent({
  name: 'PartVehicleItem',
  components: {
    DetailIcon,
    PreviewImageModal
  },
  data(): PartVehicleItemProps {
    return {
      checked: this.vehicle.checked,
      showPreviewModal: false,
      previewImg: []
    };
  },
  props: {
    vehicle: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.$bus.$on('single-check-part-vehicle', this.singleCheckPartVehicle);

    this.$bus.$on('clear-check-part-vehicle', this.clearCheckPartVehicle);

    this.$bus.$on('calculate-img', this.calculateImg);
  },
  mounted() {
    this.calculateImg();
  },
  methods: {
    calculateImg() {
      const imgs: any[] = Array.from(
        document.querySelectorAll('.p-img-container')
      );

      imgs.forEach(e => {
        if (e.parentElement) {
          e.style.height = `${(e.parentElement?.offsetWidth * 5) / 8}px`;
        }
      });
    },
    clearCheckPartVehicle() {
      this.checked = false;
    },
    singleCheckPartVehicle(id) {
      if (this.vehicle.id !== id) {
        this.checked = false;
      } else {
        this.checked = !this.checked;
      }
    },
    handleChecked() {
      this.$bus.$emit('single-check-part-vehicle', this.vehicle.id);

      this.$emit('checked', this.vehicle, !this.checked);
    },
    getImgSrc() {
      let res = '';

      const imgs = (this.vehicle.showImg || '').split(',').filter(s => s);

      if (imgs.length > 0) {
        res = `${baseFileUrl}${imgs[0]}`;
      }

      return res;
    },
    handleCatalog() {
      this.$router.push(
        `/catalogue/${this.vehicle.id}?model=${this.vehicle.modelNum || ''}`
      );
    },
    handleMovingPart() {
      this.$router.push(`/spare-part/${this.vehicle.id}`);
    },
    handleImg() {
      this.previewImg.push(
        this.vehicle.attributeImg ? baseFileUrl + this.vehicle.attributeImg : ''
      );
      this.showPreviewModal = true;
    },
    handleAfterImgModalClose() {
      this.previewImg = [];
      this.showPreviewModal = false;
    }
  }
});
